import { render, staticRenderFns } from "./add-edit-dialog.vue?vue&type=template&id=12005878&scoped=true&"
import script from "./add-edit-dialog.vue?vue&type=script&lang=js&"
export * from "./add-edit-dialog.vue?vue&type=script&lang=js&"
import style0 from "./add-edit-dialog.vue?vue&type=style&index=0&id=12005878&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12005878",
  null
  
)

export default component.exports